import { AnyIfEmpty } from 'react-redux';
import { GET_LOCKER_TYPE_FAILURE, GET_LOCKER_TYPE_REQUEST, GET_LOCKER_TYPE_SUCCESS } from '../constants/locker-version.constants';

const initialState = {
    loading: false,
    data: [],
    errorMsg: '',
};

const lockerTypeReducer = (state = initialState, action: { type: string; payload: AnyIfEmpty<object> }) => {
    switch (action.type) {
        case GET_LOCKER_TYPE_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
                errorMsg: '',
            };

        case GET_LOCKER_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };

        case GET_LOCKER_TYPE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };

        default:
            return state;
    }
};

export default lockerTypeReducer;
